<template>
  <div>
    <b-container>
      <b-row class="justify-content-center">
        <b-col lg="10">
          <h1>Portfolio</h1>
          <h2>Some of My Work</h2>
        </b-col>
      </b-row>

      <b-row class="mb-n3 mt-3 mt-lg-4">

        <b-col v-for="project in projects" md="6" lg="4" class="mb-3 mb-lg-4" :key="project.slugs">
          <router-link :to="'/portfolio/' + project.slug">
            <b-card no-body img-top class="shadow-sm" img-alt=""
              :img-src="require('../assets/thumbs/thumb-' + project.slug + '@2x.png')">
              <b-card-body body-bg-variant="light" class="py-2 border-top">
                <b-card-text class="text-center text-uppercase font-weight-bold">
                  {{ project.name }}
                </b-card-text>
              </b-card-body>
            </b-card>
          </router-link>
        </b-col>

      </b-row>
    </b-container>
  </div>
</template>

<script>
  export default {
    metaInfo: {
      titleTemplate: 'Portfolio | %s',
    },

    data () {
      return {
        projects: [
          { name: "Intuit QuickBooks Connect", slug: "intuit-quickbooks-connect" },
          { name: "Logitech Room Configurator", slug: "logitech-room-configurator" },
          { name: "Zeiss Full Exposure", slug: "zeiss-full-exposure" },
          { name: "North Park University", slug: "north-park-university" },
          { name: "Instyle Fragrances", slug: "instyle-fragrances" },
          { name: "JAXJOX", slug: "jaxjox" },
          { name: "Make Your Great", slug: "make-your-great" },
          { name: "Nature's Eats", slug: "natures-eats" },
          { name: "Q.ai", slug: "q-ai" }
          // { name: "Nikon Fan Focus", slug: "nikon" }
        ]
      }
    }
  }
</script>
